import { Stack } from '@mui/material'
import { FC, useCallback, useContext } from 'react'
import { useParams } from 'react-router-dom'

import { CenteredLoading } from '../../components'
import { NotPassedEntriesListWrapper } from '../../components/Inspections/NotPassedEntriesListWrapper'
import PassedEntriesList from '../../components/Inspections/PassedEntriesList'
import SingleEntryUIForCustomer from '../../components/Inspections/SingleEntryUIForCustomer'
import useInspectionEntriesByStatus from '../../hooks/useInspectionEntriesByStatus/useInspectionEntriesByStatus'
import { RepairOrderPortalContext } from '../../providers/RepairOrderPortalProvider/RepairOrderPortalProvider'
import {
  useGetInspectionForCustomerQuery,
  useUpdateServiceViaApiKeyMutation
} from '../../redux/api/inspectionApi'
import { ServiceEntry } from '../../sdk'

type Props = { showPrice: boolean }
const EntriesByStatusListContainerForCustomerPortal: FC<Props> = ({
  showPrice
}) => {
  const { services, associations, cannedJobs, isLoading } = useContext(
    RepairOrderPortalContext
  )

  const { apiKey } = useParams()
  const { data: inspection, isLoading: inspectionLoading } =
    useGetInspectionForCustomerQuery({
      xAPIKey: apiKey!
    })
  const { entriesByStatus } = useInspectionEntriesByStatus(
    inspection,
    cannedJobs,
    true
  )
  const [updateServiceViaApiKey] = useUpdateServiceViaApiKeyMutation()
  const handleDeferOrRecommendService = useCallback(
    async (service: ServiceEntry, isDeferral: boolean) => {
      if (!apiKey) {
        return
      }
      await updateServiceViaApiKey({
        xAPIKey: apiKey,
        customerServiceStatusRequest: {
          serviceId: service.id!,
          isDeferral
        }
      })
    },
    [apiKey, updateServiceViaApiKey]
  )

  return isLoading || inspectionLoading || !entriesByStatus ? (
    <CenteredLoading />
  ) : (
    <Stack spacing={1}>
      {entriesByStatus
        .filter((status) => !status.info!.shop)
        .map((status) => (
          <PassedEntriesList
            key={status.id}
            {...{
              status
            }}
          />
        ))}
      {entriesByStatus
        .filter((status) => !!status.info!.shop)
        .map((status) => (
          <NotPassedEntriesListWrapper {...{ status }} key={status.id!}>
            {status.entries.map((entry) => (
              <SingleEntryUIForCustomer
                key={entry.id}
                {...{
                  entry,
                  showPrice,
                  services,
                  associations,
                  handleDeferOrRecommendService
                }}
              />
            ))}
          </NotPassedEntriesListWrapper>
        ))}
    </Stack>
  )
}

export default EntriesByStatusListContainerForCustomerPortal
